<template>
  <div class="modal-overflow">
    <div v-for="incident in data" style="margin-top:10px;">
      <table class="camunda-incident">
        <colgroup>
          <col style="width:33%">
          <col style="width:67%">
        </colgroup>
        <tbody>
          <tr>
            <td><strong>Incident Type</strong></td>
            <td>{{ incident.incidentType }}</td>
          </tr>
          <tr>
            <td><strong>Failed Activity ID</strong></td>
            <td>{{ incident.failedActivityId }}</td>
          </tr>
          <tr>
            <td><strong>Message</strong></td>
            <td>{{ incident.incidentMessage }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div style="text-align: center;">
      <button type="button" @click="closeModal" class="btn btn-fill btn-info">
        Close
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    methods: {
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>

<style scoped>
.camunda-incident {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #aaa;
  color: #606266;
}
.camunda-incident td {
  border: 1px solid #aaa;
}
.camunda-incident th {
  padding: 10px;
  color: #909399;
  text-transform: uppercase;
}
.camunda-incident td {
  padding: 5px 10px;
}
</style>
